import BinIcon from '../../../components/icon/Icon';
import { BannerForwardButtonStyled } from './styled/BannerForwardButtonStyled';
import classNames from "classnames";

interface IBannerForwardButtonProps {
    background?: string;
    className?: string;
    color?: string;
}

function BannerForwardButton(props: IBannerForwardButtonProps) {
    const { className, color, background } = props;

    return <BannerForwardButtonStyled
        background={background}
        color={color}
        className={classNames(className, 'square')}
        variant={'primary'}
    >
        <BinIcon name={'IcForward'} size={24}/>
    </BannerForwardButtonStyled>
}

export default BannerForwardButton;
